import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { CheckCircle } from 'lucide-react';

const OrderSuccessModal = ({ isOpen, onClose, pricing, operationId }) => {
  const navigate = useNavigate();

  const handleViewOrders = () => {
    onClose();
    navigate('/dashboard');
  };

  // Calculate price range (±15% variation)
  const basePrice = pricing?.total || 0;
  const minPrice = Math.round(basePrice * 0.85);
  const maxPrice = Math.round(basePrice * 1.15);

  const formatPrice = (price) => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="bg-gradient-to-r from-[#1db584] to-[#16a075] -mx-6 -mt-6 px-6 py-4 rounded-t-lg">
          <DialogTitle className="text-white text-xl font-bold text-center">
            Succès de la commande
          </DialogTitle>
        </DialogHeader>
        
        <div className="flex flex-col items-center py-6 space-y-4">
          {/* Success Icon */}
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
            <CheckCircle className="w-12 h-12 text-green-600" strokeWidth={2.5} />
          </div>

          {/* Success Message */}
          <p className="text-center text-gray-900 font-semibold text-lg">
            Votre commande a été enregistrée avec succès !
          </p>

          {/* Confirmation Message */}
          <div className="bg-blue-50 border-l-4 border-[#1db584] p-4 w-full rounded">
            <p className="text-sm text-gray-700 text-center">
              Votre demande de transport a été bien enregistrée. Notre équipe va l'examiner et vous enverra un devis dans les plus brefs délais.
            </p>
          </div>

          {/* Additional Info */}
          <div className="bg-gray-50 p-4 rounded-lg w-full">
            <p className="text-sm text-gray-600 text-center">
              Vous recevrez une notification dès que le devis sera prêt. Vous pouvez également suivre l'état de votre demande dans votre tableau de bord.
            </p>
          </div>

          {/* Action Button */}
          <Button 
            onClick={handleViewOrders}
            className="w-full bg-gradient-to-r from-[#1db584] to-[#16a075] hover:from-[#16a075] hover:to-[#128f69] text-white font-semibold py-6 text-base"
          >
            Voir mes commandes
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default OrderSuccessModal;
